/**
 * "Batteries & devices" maintenance report (server ha/maintenance.ts).
 *
 *   GET  /api/homes/:home/maintenance                 → MaintenanceReport (module `maintenance`)
 *   POST /api/homes/:home/maintenance/marks           {key, state: 'ignored'|'retired'|null}   admin
 *   POST /api/homes/:home/maintenance/replaced        {key}                                     admin (batteries)
 *   POST /api/homes/:home/maintenance/todos           {target, title, note?, unreliableTemp?}   admin
 *   POST /api/homes/:home/maintenance/todos/:id/done  {}                                        admin
 *
 * Live: the server pushes `{t:'maintenance', home, version}` (WS) whenever a home's report
 * changes (recomputed on diffs, throttled); clients refetch the REST report.
 */
import { z } from 'zod';
export const MaintenanceMarkBody = z.object({ key: z.string().min(1).max(200), state: z.enum(['ignored', 'retired']).nullable() });
export const MaintenanceReplacedBody = z.object({ key: z.string().min(1).max(200) });
export const MaintenanceTodoBody = z.object({
    target: z.object({ kind: z.enum(['device', 'entity']), id: z.string().min(1).max(200) }),
    title: z.string().trim().min(1).max(120),
    note: z.string().trim().max(500).optional(),
    unreliableTemp: z.boolean().optional(),
});
//# sourceMappingURL=maintenance.js.map